<template>
    <button type="button"
            v-bind:disabled="disabled"
            @click="$emit('click')"
            v-bind:style="style"
            v-bind:type="type">
        <div class="button-text">
            <i v-if="icon" v-bind:class="icon"></i>
            <slot></slot>
            <v-ons-progress-circular v-show="in_progress" indeterminate/>
        </div>
    </button>
</template>

<script>
export default {

    props: {
        'icon': {
            type: String,
            default: "",
        },
        'disabled': {
            type: Boolean,
            default: false,
        },
        'click': {
            type: Boolean,
            default: true,
        },
        'in_progress': {
            type: Boolean,
            default: false,
        },
        'type': {
            type: String,
            default: 'button',
        }
    }, 

    data () {
        return {

        }
    },

    computed: {
        style() {
            const style = {}
            if (this.click == false)
                style['pointer-events'] = 'none'
            return style
        }
    }
}
</script>

<style scoped>

button {
    width: 100%;
    max-width: var(--global-btn-max-width);
    height: 50px;
    line-height: 50px;
    border-radius: var(--global-border-radius);
    border: 0px;
    font-weight: bold;
    border: none;
    outline: none;
    margin-right: auto;
    margin-left: auto;
    display: block;
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
}

.round {
    margin: 0px 10px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}

button.round {
    border-radius: 30px;
    padding: 0px;
    width: 44px;
    height: 44px;
}

button.primary {
    background: var(--global-goodtill-green);
    color:white;
}

button.secondary {
    background: #F3F4F4;
    color: #4B4C4C;
}

button.tertiary {
    background: #ecfaf6;
    color: #1A1824;
}

button.small {
    padding: 10px;
    height: 34px;
    line-height: 17px;
    font-weight: normal;
}

button i {
    float: left;
    line-height: inherit;
}

.button-text > * {
    vertical-align: middle;
}

button[disabled="disabled"] {
    opacity: 0.65;
}
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/gtc_button.vue